exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-menu .active .fa-plus:before {\n  content: \"\\F067\" !important;\n}\n\n.open-menu {\n  background: #dedede;\n  display: block;\n}\n\n.open-menu a {\n  padding: 10px 5px 10px 12px;\n  display: block;\n  font-size: 13px;\n  min-height: 42px;\n  color: #333;\n  padding-left: 20px;\n  min-width: 200px;\n}\n\n.moz-button-set {\n  position: absolute;\n  right: 10px;\n}\n\n.fa-sign-in:before {\n  color: #000;\n}\n\n.fa-lock:before {\n  color: #000;\n}\n\n.fa-exchange:before {\n  color: inherit !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/sidebar/sidebar.component.css
// module id = ../../../../../src/app/main/sidebar/sidebar.component.css
// module chunks = main